import { render, staticRenderFns } from "./ProductsCarouselModal.vue?vue&type=template&id=6c3fb6fe&scoped=true&"
import script from "./ProductsCarouselModal.vue?vue&type=script&lang=js&"
export * from "./ProductsCarouselModal.vue?vue&type=script&lang=js&"
import style0 from "./ProductsCarouselModal.vue?vue&type=style&index=0&id=6c3fb6fe&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c3fb6fe",
  null
  
)

export default component.exports